<script setup lang="ts">
import { useDisplay } from 'vuetify'
import { isTelegram } from '@/utils/isTelegram'
import SectionHeader from '@/components/SectionHeader.vue'

const { mobile } = useDisplay()

const dashboards = [
  {
    title: 'Папка дашбордов VPN',
    description: 'Все дашборды, отчеты и графики нашего проекта в Grafana',
    url: 'https://grafana.digital-security.pro/dashboards/f/efpqy8xjmgxkwa/?orgId=1',
    icon: 'ri-folder-open-line',
    color: '#ffc048'
  },
  {
    title: 'Прибыльность нашего дела',
    description: 'Анализ выручки, транзакций и прибыли по дням/месяцам в Apache Superset',
    url: 'https://analytic.digital-security.pro/superset/dashboard/2/',
    icon: 'ri-money-dollar-box-line',
    color: '#00d2ff'
  },
  {
    title: 'Лучшие рефереры',
    description: 'Рейтинг пользователей по количеству приглашенных рефералов',
    url: 'https://analytic.digital-security.pro/superset/dashboard/4/',
    icon: 'ri-group-line',
    color: '#00f5d4'
  },
  {
    title: 'Общий обзор (Overview)',
    description: 'Главный технический дашборд состояния всей инфраструктуры',
    url: 'https://grafana.digital-security.pro/d/overview/overview',
    icon: 'ri-dashboard-3-line',
    color: '#ff9f43'
  },
  {
    title: 'Мониторинг серверов',
    description: 'Нагрузка процессора, память, диски и сеть (Node Exporter Full)',
    url: 'https://grafana.digital-security.pro/d/node_exporter_full/node-exporter-full',
    icon: 'ri-server-line',
    color: '#ff6b6b'
  },
  {
    title: 'Ресурсы Kubernetes',
    description: 'Использование ресурсов кластера, подов и контейнеров K8s',
    url: 'https://grafana.digital-security.pro/d/efa86fd1d0c121a26444b636a3f509a8/kubernetes-compute-resources-cluster',
    icon: 'ri-cloud-line',
    color: '#a55eea'
  },
  {
    title: 'Prometheus & Alertmanager',
    description: 'Статус сбора системных метрик и активные триггеры/алерты',
    url: 'https://grafana.digital-security.pro/d/9fa0d141-d019-4ad7-8bc5-42196ee308bd/prometheus-overview',
    icon: 'ri-alert-line',
    color: '#fffa65'
  }
]
</script>

<template>
  <div class="d-flex flex-column ga-6 w-100 pt-4" :class="{ 'pa-4': isTelegram() || mobile }" style="max-width: 100vw; box-sizing: border-box;">
    <header>
      <section-header title="Мониторинг и статистика" />
    </header>

    <v-row class="ma-0 w-100">
      <v-col
        v-for="board in dashboards"
        :key="board.url"
        cols="12"
        sm="6"
        md="4"
        class="pa-2"
      >
        <v-card
          :href="board.url"
          target="_blank"
          variant="flat"
          color="surface"
          class="dashboard-card pa-4 d-flex flex-column justify-space-between h-100 rounded-lg border-subtle"
        >
          <div class="d-flex align-start justify-space-between ga-2 mb-3">
            <div 
              class="icon-wrapper d-flex align-center justify-center rounded-lg"
              :style="{ backgroundColor: board.color + '15', color: board.color }"
            >
              <v-icon size="24">{{ board.icon }}</v-icon>
            </div>
            <v-icon size="18" class="text-text-disabled shrink-0 mt-1">ri-arrow-right-up-line</v-icon>
          </div>

          <div>
            <div class="text-subtitle-1 font-weight-bold mb-1 text-high-emphasis">
              {{ board.title }}
            </div>
            <div class="text-caption text-text-disabled line-height-sm">
              {{ board.description }}
            </div>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<style scoped>
.border-subtle {
  border: 1px solid rgba(255, 255, 255, 0.05) !important;
}

.icon-wrapper {
  width: 44px;
  height: 44px;
}

.dashboard-card {
  transition: all 0.2s ease-in-out;
}

.dashboard-card:hover {
  transform: translateY(-2px);
  border-color: rgba(255, 255, 255, 0.15) !important;
  background-color: rgba(255, 255, 255, 0.02) !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2) !important;
}

.line-height-sm {
  line-height: 1.3 !important;
}
</style>
